/* DARKSTIMS · PUMP V2 + FREE Liquid Glycerol landing page (only loaded by sections/ds-pump-free-glycerol-landing.liquid) */
(function () {
  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var cfg = JSON.parse(root.querySelector('[data-dsfe-config]').textContent);
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var TAG = 'pump-free-glyc';
    var sel = { pre: null, el: cfg.elVariantId || null };
    var lastFocus = null;

    function pressed(group) { return root.querySelector('.dsfe-chip[data-group="' + group + '"][aria-pressed="true"]:not([disabled])') || root.querySelector('.dsfe-chip[data-group="' + group + '"]:not([disabled])'); }
    function pick(chip) {
      var g = chip.dataset.group;
      root.querySelectorAll('.dsfe-chip[data-group="' + g + '"]').forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
      sel[g] = Number(chip.dataset.id);
      root.querySelectorAll('[data-dsfe-name="' + g + '"]').forEach(function (n) { n.textContent = chip.dataset.name; });
      root.querySelectorAll('img[data-dsfe-img="' + g + '"]').forEach(function (img) { img.src = chip.dataset.img; img.removeAttribute('srcset'); });
    }
    var c0 = pressed('pre'); if (c0) pick(c0);
    root.querySelectorAll('.dsfe-chip').forEach(function (c) { c.addEventListener('click', function () { pick(c); }); });

    function money(cents) {
      var sym = cfg.currency === 'GBP' ? '£' : (cfg.currency === 'EUR' ? '€' : (cfg.currency === 'USD' ? '$' : ''));
      return sym + (cents / 100).toFixed(2) + (sym ? '' : ' ' + cfg.currency);
    }
    function req(path, body) {
      return fetch(base + path, {
        method: body ? 'POST' : 'GET',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: body ? JSON.stringify(body) : undefined
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
    }
    function getCart() { return req('cart.js'); }
    function isLp(item) { return item.properties && item.properties._lp === TAG; }
    function otherSpend(cart) {
      // Spend on everything except the creatine add-on and the free Glycerol
      var total = 0;
      cart.items.forEach(function (i) { if (i.variant_id !== cfg.creatineVariantId && i.product_id !== cfg.elProductId) total += i.original_line_price; });
      return total;
    }
    function creatineEligible(cart) { return otherSpend(cart) > cfg.creatineMinSpend; }
    function codesFor(cart) {
      var codes = [cfg.freeCode];
      if (cfg.creatineCode && creatineEligible(cart) && cart.items.some(function (i) { return isLp(i) && i.variant_id === cfg.creatineVariantId; })) codes.push(cfg.creatineCode);
      return codes.filter(Boolean).join(',');
    }
    function applyCodes(cart) { return req('cart/update.js', { discount: codesFor(cart) }); }
    function refreshTheme() { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); }

    function render(cart) {
      var wrap = root.querySelector('[data-dsfe-lines]');
      wrap.innerHTML = '';
      cart.items.forEach(function (item) {
        var line = document.createElement('div');
        line.className = 'dsfe-line';
        var img = document.createElement('img');
        img.src = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
        img.alt = '';
        var info = document.createElement('div');
        info.className = 'dsfe-line__info';
        var t = document.createElement('b'); t.textContent = item.product_title;
        var v = document.createElement('span');
        v.textContent = (item.variant_title ? item.variant_title + ' · ' : '') + 'Qty ' + item.quantity;
        var rm = document.createElement('button');
        rm.type = 'button'; rm.className = 'dsfe-line__rm'; rm.textContent = 'Remove';
        rm.addEventListener('click', function () { change(item.key, 0); });
        info.appendChild(t); info.appendChild(document.createElement('br')); info.appendChild(v); info.appendChild(document.createElement('br')); info.appendChild(rm);
        var price = document.createElement('div');
        price.className = 'dsfe-line__price';
        if (item.final_line_price < item.original_line_price) {
          var s = document.createElement('s'); s.textContent = money(item.original_line_price); price.appendChild(s);
        }
        var now = document.createElement('span');
        now.textContent = item.final_line_price === 0 ? 'FREE' : money(item.final_line_price);
        if (item.final_line_price === 0) now.className = 'is-free';
        price.appendChild(now);
        line.appendChild(img); line.appendChild(info); line.appendChild(price);
        wrap.appendChild(line);
      });
      var applied = (cart.discount_codes || []).some(function (d) { return d.code && d.code.toUpperCase() === String(cfg.freeCode).toUpperCase() && d.applicable; })
        || cart.items.some(function (i) { return i.product_id === cfg.elProductId && i.final_line_price < i.original_line_price; });
      root.querySelector('[data-dsfe-applied]').hidden = !applied;
      var addon = root.querySelector('[data-dsfe-addon]');
      if (addon) addon.hidden = !creatineEligible(cart) || cart.items.some(function (i) { return i.variant_id === cfg.creatineVariantId; });
      root.querySelector('[data-dsfe-subtotal]').textContent = money(cart.total_price);
    }

    function open(name) {
      lastFocus = document.activeElement;
      root.querySelectorAll('[data-dsfe-overlay]').forEach(function (o) { o.classList.toggle('is-open', o.dataset.dsfeOverlay === name); });
      document.documentElement.classList.add('dsfe-lock');
      var ov = root.querySelector('[data-dsfe-overlay="' + name + '"]');
      var x = ov && ov.querySelector('[data-dsfe-close]');
      if (x) x.focus();
    }
    function closeAll() {
      root.querySelectorAll('[data-dsfe-overlay]').forEach(function (o) { o.classList.remove('is-open'); });
      document.documentElement.classList.remove('dsfe-lock');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    root.querySelectorAll('[data-dsfe-overlay]').forEach(function (o) {
      o.addEventListener('click', function (e) { if (e.target === o) closeAll(); });
      o.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    });
    root.querySelectorAll('[data-dsfe-close]').forEach(function (b) { b.addEventListener('click', closeAll); });
    root.querySelectorAll('[data-dsfe-open="reviews"]').forEach(function (b) { b.addEventListener('click', function () { open('reviews'); }); });

    function busy(on) { root.querySelectorAll('[data-dsfe-add]').forEach(function (b) { b.setAttribute('aria-busy', on ? 'true' : 'false'); }); }
    function showError(msg) { var e = root.querySelector('[data-dsfe-error]'); e.textContent = msg || ''; e.hidden = !msg; }

    function addBoth() {
      if (!sel.pre || !sel.el) { showError('Pick your PUMP V2 flavour.'); return; }
      showError(''); busy(true);
      getCart().then(function (cart) {
        // Replace any earlier pair added from this page (e.g. a flavour change) so the free bottle stays 1 per order.
        var updates = {}; var any = false;
        cart.items.forEach(function (i) { if (isLp(i) && (i.product_id === cfg.preProductId || i.product_id === cfg.elProductId)) { updates[i.key] = 0; any = true; } });
        return any ? req('cart/update.js', { updates: updates }) : cart;
      }).then(function () {
        return req('cart/add.js', { items: [
          { id: sel.pre, quantity: 1, properties: { _lp: TAG } },
          { id: sel.el, quantity: 1, properties: { _lp: TAG } }
        ] });
      }).then(getCart).then(applyCodes).then(getCart).then(function (cart) {
        render(cart); refreshTheme(); open('cart');
      }).catch(function (err) {
        showError((err && (err.description || err.message)) || 'Something went wrong. Please try again.');
      }).finally(function () { busy(false); });
    }
    root.querySelectorAll('[data-dsfe-add]').forEach(function (b) { b.addEventListener('click', addBoth); });

    function change(key, qty) {
      req('cart/change.js', { id: key, quantity: qty }).then(applyCodes).then(getCart).then(function (cart) { render(cart); refreshTheme(); });
    }
    var addonBtn = root.querySelector('[data-dsfe-addon-btn]');
    if (addonBtn && cfg.creatineVariantId) {
      addonBtn.addEventListener('click', function () {
        addonBtn.setAttribute('aria-busy', 'true');
        req('cart/add.js', { items: [{ id: cfg.creatineVariantId, quantity: 1, properties: { _lp: TAG } }] })
          .then(getCart).then(applyCodes).then(getCart)
          .then(function (cart) { render(cart); refreshTheme(); })
          .finally(function () { addonBtn.removeAttribute('aria-busy'); });
      });
    }
    root.querySelector('[data-dsfe-checkout]').addEventListener('click', function () { window.location.href = base + 'checkout'; });

    // Sticky bar once the buy box has scrolled away
    var sticky = root.querySelector('[data-dsfe-sticky]');
    var buy = root.querySelector('[data-dsfe-buy]');
    if (sticky && buy && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        sticky.querySelector('button').tabIndex = show ? 0 : -1;
      }, { threshold: 0 }).observe(buy);
    }
  }
  function boot() { document.querySelectorAll('[data-dsfe-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();